import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import {
	InfosRetourTeletransGPWSDTO,
	SoignantOutputIndicateurWSDTO,
} from "src/app-ay/core/layout/components/side-nav/components/paiement-menu-item/indicateurs.model";

@Injectable()
export class IndicateursApi {
	private readonly http = inject(HttpClient);

	getIndicateursRejetsATraiter(soignantId: number): Observable<InfosRetourTeletransGPWSDTO> {
		return this.http
			.post<SoignantOutputIndicateurWSDTO>(`${environment.apiEmotion()}/v2/soignants/indicateurs`, {
				soignantIds: [soignantId],
				paramInfosRetourTeletransGP: {
					execute: true,
				},
			})
			.pipe(
				map(({ soignantIndicateurs }) => {
					const infosRetourTeletransGP = soignantIndicateurs.find(
						(item) => Number(item.soignantId) === soignantId,
					)?.infosRetourTeletransGP;
					if (infosRetourTeletransGP === undefined) {
						throw new Error("Soignant non trouvé dans la réponse des indicateurs");
					}
					return infosRetourTeletransGP;
				}),
			);
	}
}
